// ErrorDialog.tsx
import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from '@mui/material';

interface ErrorDialogProps {
  open: boolean;
  onClose: () => void;
  message: string | null;
  onExited?: () => void; // add this
}

const ErrorDialog: React.FC<ErrorDialogProps> = ({ open, onClose, message, onExited }) => {
  return (
    <Dialog open={open} onClose={onClose} TransitionProps={{ onExited }} >
      <DialogTitle>Error</DialogTitle>
      <DialogContent>
        <Typography variant="body1">{message}</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ErrorDialog;
